import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string;
  trend?: number;
  trendLabel?: string;
  icon: React.ReactNode;
}
export function MetricCard({
  title,
  value,
  trend,
  trendLabel,
  icon
}: MetricCardProps) {
  const isPositive = trend && trend > 0;
  const isNeutral = trend === 0;
  return <Card data-id="element-246">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2" data-id="element-247">
        <CardTitle className="text-sm font-medium text-muted-foreground" data-id="element-248">
          {title}
        </CardTitle>
        <div className="text-muted-foreground" data-id="element-249">{icon}</div>
      </CardHeader>
      <CardContent data-id="element-250">
        <div className="text-2xl font-bold" data-id="element-251">{value}</div>
        {trend !== undefined && <p className="text-xs flex items-center mt-1" data-id="element-252">
            {isPositive ? <ArrowUpRight className="mr-1 h-4 w-4 text-green-500" data-id="element-253" /> : isNeutral ? <Minus className="mr-1 h-4 w-4 text-gray-500" data-id="element-254" /> : <ArrowDownRight className="mr-1 h-4 w-4 text-red-500" data-id="element-255" />}
            <span className={isPositive ? 'text-green-500 font-medium' : isNeutral ? 'text-gray-500' : 'text-red-500 font-medium'} data-id="element-256">
              {Math.abs(trend)}%
            </span>
            <span className="text-muted-foreground ml-1" data-id="element-257">
              {trendLabel || 'vs last month'}
            </span>
          </p>}
      </CardContent>
    </Card>;
}